import { createAsyncThunk } from '@reduxjs/toolkit';

import api from 'api';

export const loadServiceProviderFullInfo = createAsyncThunk(
    'app/loadServiceProviderFullInfo',
    async (providerId: string, { dispatch }) => {
        await dispatch(loadServiceProvider(providerId));
        dispatch(loadServiceProviderLogo(providerId));
    }
);

export const loadServiceProvider = createAsyncThunk(
    'api/service_provider/{service_provider_id}',
    async (id: string) => await api.serviceProvider.get(id)
);

export const loadServiceProviderLogo = createAsyncThunk(
    'api/resource/logo',
    async (id: string) => await api.resource.get('logo', id)
);
